import { UseUrlsType } from '../zustand/types';
import useUrlsStore from '../zustand/urlsStore';

const useUrls = (): UseUrlsType => {
  const purchaseUrl = useUrlsStore((state) => state.purchaseUrl);
  const setPurchaseUrl = useUrlsStore((state) => state.setPurchaseUrl);

  return {
    ids: { purchaseUrl },
    actions: { setPurchaseUrl },
  };
};

export default useUrls;
